function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crn0gbn2ua"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4435",
    transform: "translate(294 83)",
    style: {
      fill: "#032541"
    },
    d: "M0 0h20v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17846",
    transform: "translate(-294 -83)",
    style: {
      clipPath: "url(#crn0gbn2ua)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25410",
    d: "M12.349 29.491.894 18.035a1 1 0 0 1-.228-.326 1.02 1.02 0 0 1 0-.718 1 1 0 0 1 .228-.326L12.349 5.209a1.343 1.343 0 0 1 1.828 0 1.3 1.3 0 0 1 0 1.86L3.9 17.35l10.277 10.281a1.214 1.214 0 0 1 .375.93 1.309 1.309 0 0 1-1.305 1.289 1.217 1.217 0 0 1-.898-.359z",
    transform: "translate(293.4 80.15)",
    style: {
      fill: "#032541"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcn);
export default __webpack_public_path__ + "static/media/back-icn.4c426008c8109de43fa8ffe66e0f0498.svg";
export { ForwardRef as ReactComponent };